<!-- 首页底部分类统计组件 -->
<template>
    <div class="v-category">
        <Row class="category-panel" :gutter="54" v-if="loadDict">
            <Col span="6" v-for="(item, index) in CategoryData" :key="index" class="category-item">
            <div class="category-item" :class="'category-item-' + index" @click="selectItem(item)">
                <i></i>
                <span>{{ item.label + '（' + item.value + '）' }}</span>
            </div>
            </Col>
        </Row>
    </div>
</template>

<script>
    export default {
        name: 'VCategory',
        components: {

        },
        props: {
            // 请求字典表结束后加装字典表
            loadDict: {
                type: Boolean,
                default() {
                    return false
                }
            }
        },
        data() {
            return {
                // 聚合数据
                LawAggData: {},
                // 法规类别字典表
                LawTypeOption: [],
                // 分类导航数据
                CategoryData: [
                    {
                        id: '',
                        label: '法律',
                        value: ''
                    },
                    {
                        id: '',
                        label: '行政法规',
                        value: ''
                    },
                    {
                        id: '',
                        label: '部门规章',
                        value: ''
                    },
                    {
                        id: '',
                        label: '省级地方性法规',
                        value: ''
                    }
                ],
                // 路由名称
                routerName: 'LawList'
            }
        },
        computed: {

        },
        watch: {
            // 请求字典表结束后加装字典表
            loadDict: {
                handler(data) {
                    this.loadDict = data;
                    this.LawAggData = this.$store.state.lawAggData;
                    this.LawTypeOption = this.$store.state.dict.lawType;
                    this.buildCategoryData();
                },
            },
        },
        created() {

        },
        mounted() {

        },
        destroyed() {

        },
        methods: {
            selectItem(item) {
                this.$router.push({ name: this.routerName, query: { id: item.id }, params: item });
            },
            // 功能 组织分类数据格式
            buildCategoryData() {
                this.CategoryData.forEach(item => {
                    this.LawAggData.aggLawEffectLevelNum.forEach(v => {
                        if (item.label == v.effect_level_name) {
                            item.value = v.num;
                            item.id = v.effect_level_id;
                        }
                    });
                });

            }
        },
        filter: {

        }
    }
</script>

<style scoped>
    .category-panel {
        margin: 0 0 50PX 0;
    }

    .category-item {
        padding: 24px 0;
        border-radius: 3px;
        text-align: center;
        color: #fff;
        cursor: pointer;
    }

    .category-item i {
        display: flex;
        margin: 10px auto 0px;
        width: 44px;
        height: 50px;
        transform: scale(0.8);
        background-size: 80% 80%;
    }

    .category-item-0 {
        background-color: #07bddb;
    }

    .category-item-1 {
        background-color: #ff9900;
    }

    .category-item-2 {
        background-color: #5175a3;
    }

    .category-item-3 {
        background-color: #1867DD;
    }

    .category-item-0 i {
        background: url(../../assets/img/icon-law.png) 0 0 no-repeat;
    }

    .category-item-1 i {
        background: url(../../assets/img/icon-xzfg.png) 0 0 no-repeat;
    }

    .category-item-2 i {
        background: url(../../assets/img/icon-bmgz.png) 0 0 no-repeat;
    }

    .category-item-3 i {
        background: url(../../assets/img/icon-dfxfg.png) 0 0 no-repeat;
    }
</style>